// src/utils/streamRequest.js

/**
 * POST 流式请求（替代 SSE，支持 Body 传参）
 * @param {String} url - 接口地址
 * @param {Object} data - Body 参数
 * @param {Function} onMessage - 接收流式数据的回调
 * @param {Function} onError - 错误回调
 * @param {Function} onComplete - 流结束回调
 * @returns {Promise} 取消请求的函数
 */
export function streamGet(url, params, onMessage, onError, onComplete) {
  const ctrl = new AbortController();
  const token = localStorage.getItem('bell_admin_token') || ''
  let url0 = url
  let qs = ''
  if (params instanceof URLSearchParams) {
    qs = params.toString()
  } else {
    const p = params || {}
    const keys = Object.keys(p)
    const parts = []
    for (let i = 0; i < keys.length; i++) {
      const k = keys[i]
      const v = p[k]
      if (v == null) continue
      if (Array.isArray(v)) {
        const prim = v.every(x => x == null || typeof x !== 'object')
        if (prim) {
          for (let j = 0; j < v.length; j++) {
            const x = v[j]
            parts.push(encodeURIComponent(k) + '=' + encodeURIComponent(String(x)))
          }
        } else {
          parts.push(encodeURIComponent(k) + '=' + encodeURIComponent(JSON.stringify(v)))
        }
      } else if (typeof v === 'object') {
        parts.push(encodeURIComponent(k) + '=' + encodeURIComponent(JSON.stringify(v)))
      } else {
        parts.push(encodeURIComponent(k) + '=' + encodeURIComponent(String(v)))
      }
    }
    qs = parts.join('&')
  }
  if (qs) url0 += (url0.indexOf('?') >= 0 ? '&' : '?') + qs
  console.log(url0, + ' ')

  const headers = {
    Accept: 'text/event-stream'
  }
  if (token) headers.Authorization = token.startsWith('Bearer ') ? token : ('Bearer ' + token)

  fetch(url0, {
    method: 'GET',
    headers,
    signal: ctrl.signal,
    credentials: 'include'
  })
  .then(async (resp) => {
    if (!resp || !resp.ok) {
      throw new Error(String(resp && resp.status))
    }
    const ct = resp.headers.get('content-type') || ''
    if (ct.indexOf('text/event-stream') < 0 || !resp.body) {
      const text = await resp.text()
      let json
      try { json = JSON.parse(text) } catch (e) { json = text }
      if (onMessage) onMessage(json)
      if (onComplete) onComplete()
      return
    }
    const reader = resp.body.getReader()
    const decoder = new TextDecoder('utf-8')
    let buffer = ''
    let fullText = ''
    let stopped = false
    while (true) {
      const { done, value } = await reader.read()
      if (done) {
        if (onComplete) onComplete()
        break
      }
      buffer += decoder.decode(value, { stream: true })
      const chunks = buffer.split('\n\n')
      buffer = chunks.pop() || ''
      for (let i = 0; i < chunks.length; i++) {
        const chunk = chunks[i]
        const rows = chunk.split('\n')
        const dataLines = []
        for (let r = 0; r < rows.length; r++) {
          const row = rows[r].trim()
          if (row.indexOf('data:') === 0) {
            const sRow = row.replace(/^data:\s?/, '')
            dataLines.push(sRow)
          }
        }
        if (dataLines.length === 0) continue
        const s = dataLines.join('\n').trim()
        if (s === '[DONE]') {
          if (onMessage) onMessage({ full: fullText, done: true })
          if (onComplete) onComplete()
          reader.cancel()
          stopped = true
          break
        }
        try {
          const payload = JSON.parse(s)
          const arr = Array.isArray(payload)
            ? payload
            : (payload && payload.data && Array.isArray(payload.data)
              ? payload.data
              : [])
          for (let j = 0; j < arr.length; j++) {
            const item = arr[j]
            if (item && item.finish_reason === 'stop') {
              if (onMessage) onMessage({ full: fullText, done: true })
              if (onComplete) onComplete()
              reader.cancel()
              stopped = true
              break
            }
            const txt = item && item.message && typeof item.message.content === 'string'
              ? item.message.content
              : ''
            const rc = item && item.message && typeof item.message.reasoning_content === 'string'
              ? item.message.reasoning_content
              : ''
            if (rc && onMessage) onMessage({ reasoning_content: rc })
            if (txt) {
              fullText += txt
              if (onMessage) onMessage({ content: txt })
            }
          }
        } catch (e) {
          if (onError) onError(new Error('流式数据解析失败'))
        }
      }
      if (stopped) break
    }
  }).catch((err) => {
    if (onError) onError(err)
  })

  return () => ctrl.abort()
}

export function streamPost(url, data, onMessage, onError, onComplete) {
  const ctrl = new AbortController();
  const token = localStorage.getItem('bell_admin_token') || '';
  const headers = {
    Accept: '*/*',
    'Content-Type': 'application/json; charset=utf-8',
  };
  if (token) {
    headers.Authorization =
      token.startsWith('Bearer ') ? token : 'Bearer ' + token;
  }

  fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(data || {}),
    signal: ctrl.signal,
    credentials: 'include',
  })
    .then(async (resp) => {
      if (!resp || !resp.ok) {
        throw new Error(String(resp && resp.status));
      }
      const ct = resp.headers.get('content-type') || '';
      if (ct.indexOf('text/event-stream') >= 0 && resp.body) {
        const reader = resp.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let buffer = '';
        while (true) {
          const { done, value } = await reader.read();
          if (done) {
            if (onComplete) onComplete();
            break;
          }
          buffer += decoder.decode(value, { stream: true });
          const lines = buffer.split('\n\n');
          buffer = lines.pop() || '';
          for (let i = 0; i < lines.length; i++) {
            const line = lines[i];
            if (line.indexOf('data: ') === 0) {
              const s = line.slice(6);
              if (s === '[DONE]') {
                if (onComplete) onComplete();
                reader.cancel();
                break;
              }
              try {
                const payload = JSON.parse(s);
                const arr = Array.isArray(payload) ? payload : (payload && payload.data && Array.isArray(payload.data) ? payload.data : [])
                for (let j = 0; j < arr.length; j++) {
                  const item = arr[j]
                  if (item && item.finish_reason === 'stop') {
                    if (onComplete) onComplete()
                    reader.cancel()
                    break
                  }
                  const txt = item && item.message && typeof item.message.content === 'string' ? item.message.content : ''
                  if (txt && onMessage) onMessage({ content: txt })
                }
              } catch (e) {
                if (onError) onError(new Error('流式数据解析失败'));
              }
            }
          }
        }
      } else {
        const text = await resp.text();
        let json;
        try { json = JSON.parse(text); } catch (e) { json = text; }
        if (Array.isArray(json)) {
          for (let i = 0; i < json.length; i++) {
            if (onMessage) onMessage(json[i]);
          }
        } else if (json && json.data && Array.isArray(json.data)) {
          for (let i = 0; i < json.data.length; i++) {
            if (onMessage) onMessage(json.data[i]);
          }
        } else {
          if (onMessage) onMessage(json);
        }
        if (onComplete) onComplete();
      }
    })
    .catch((err) => {
      if (onError) onError(err);
    });

  return () => ctrl.abort();
}
